<template lang="html">
  <div class="welcome-page" v-if="welcomeFlag">
    <div>
      <img class="bg" src="../../assets/welcome.png" />
      <img class="close" src="../../assets/close.png" @click="closeWel"/>
      <cube-button class="red-button" @click="closeWel">确 定</cube-button>
    </div>
  </div>
</template>
<script type="ecmascript-6">
export default {
  name: "welcome-page",
  data() {
    return {
      welcomeFlag: false,
      // welcomeNum: sessionStorage.welcomeNum || 0,
    }
  },
  mounted() {
    // if (this.welcomeNum == 0) {
    //   this.welcomeFlag = true
    //   this.welcomeNum++
    //   sessionStorage.setItem("welcomeNum", this.welcomeFlag)
    // }
  },
  methods: {
    //关闭 欢迎弹层
    closeWel() {
      this.welcomeFlag = false;
    },
    showWel() {
      this.welcomeFlag = true;
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.welcome-page {
  position: fixed
  top: 0
  left:0
  height: 100%
  width: 100vw
  z-index: 100
  background-color: rgba(0,0,0,0.5)
  >div {
    position: relative
    margin: 0 auto
    width: 80vw;
    top: 50%; /*偏移*/
    transform: translateY(-50%);
    border-radius: 10px
    .bg {
      width: 100%;
    }
    .close {
      position: absolute
      top: -30px
      right: 0
      width: 25px
    }
    button {
      position: absolute
      bottom: 20px
      left: 5vw
      width: 70vw
      border-radius: 10px
    }
  }
}
</style>
